/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCartonSizesRouteImport } from './routes/_app/carton-sizes'
import { Route as AppCategoriesRouteImport } from './routes/_app/categories'
import { Route as AppClientCodesRouteImport } from './routes/_app/client-codes'
import { Route as AppColoursRouteImport } from './routes/_app/colours'
import { Route as AppDesignsRouteImport } from './routes/_app/designs'
import { Route as AppDriversRouteImport } from './routes/_app/drivers'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppLocationsRouteImport } from './routes/_app/locations'
import { Route as AppLogisticsAssignmentRouteImport } from './routes/_app/logistics-assignment'
import { Route as AppLogisticsCalendarRouteImport } from './routes/_app/logistics-calendar'
import { Route as AppLogisticsDeliveriesRouteImport } from './routes/_app/logistics-deliveries'
import { Route as AppLogisticsProductsRouteImport } from './routes/_app/logistics-products'
import { Route as AppLogisticsSyncRouteImport } from './routes/_app/logistics-sync'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppSizesRouteImport } from './routes/_app/sizes'
import { Route as AppStockAdjustmentRouteImport } from './routes/_app/stock-adjustment'
import { Route as AppStockInRouteImport } from './routes/_app/stock-in'
import { Route as AppStockOutRouteImport } from './routes/_app/stock-out'
import { Route as AppStockReservationRouteImport } from './routes/_app/stock-reservation'
import { Route as AppStockTransferRouteImport } from './routes/_app/stock-transfer'
import { Route as AppUserRolesRouteImport } from './routes/_app/user-roles'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppVehiclesRouteImport } from './routes/_app/vehicles'
import { Route as AppWarehousesRouteImport } from './routes/_app/warehouses'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory.index'
import { Route as AppInventoryByProductRouteImport } from './routes/_app/inventory.by-product'
import { Route as AppInventoryDateBasedRouteImport } from './routes/_app/inventory.date-based'
import { Route as AppInventorySummaryRouteImport } from './routes/_app/inventory.summary'
import { Route as AppLogisticsDeliveriesIdRouteImport } from './routes/_app/logistics-deliveries_.$id'
import { Route as AppLogisticsDeliveriesNewRouteImport } from './routes/_app/logistics-deliveries_.new'
import { Route as AppStockAdjustmentIdRouteImport } from './routes/_app/stock-adjustment_.$id'
import { Route as AppStockAdjustmentNewRouteImport } from './routes/_app/stock-adjustment_.new'
import { Route as AppStockInIdRouteImport } from './routes/_app/stock-in_.$id'
import { Route as AppStockInNewRouteImport } from './routes/_app/stock-in_.new'
import { Route as AppStockOutIdRouteImport } from './routes/_app/stock-out_.$id'
import { Route as AppStockOutNewRouteImport } from './routes/_app/stock-out_.new'
import { Route as AppStockReservationIdRouteImport } from './routes/_app/stock-reservation_.$id'
import { Route as AppStockReservationNewRouteImport } from './routes/_app/stock-reservation_.new'
import { Route as AppStockTransferIdRouteImport } from './routes/_app/stock-transfer_.$id'
import { Route as AppStockTransferNewRouteImport } from './routes/_app/stock-transfer_.new'
import { Route as AppStockValuationCostsRouteImport } from './routes/_app/stock-valuation.costs'
import { Route as AppStockValuationReceiptsRouteImport } from './routes/_app/stock-valuation.receipts'
import { Route as AppStockValuationReportRouteImport } from './routes/_app/stock-valuation.report'
import { Route as AppLogisticsDeliveriesIdEditRouteImport } from './routes/_app/logistics-deliveries_.$id_.edit'
import { Route as AppStockAdjustmentIdEditRouteImport } from './routes/_app/stock-adjustment_.$id_.edit'
import { Route as AppStockInIdEditRouteImport } from './routes/_app/stock-in_.$id_.edit'
import { Route as AppStockOutIdEditRouteImport } from './routes/_app/stock-out_.$id_.edit'
import { Route as AppStockReservationIdEditRouteImport } from './routes/_app/stock-reservation_.$id_.edit'
import { Route as AppStockTransferIdEditRouteImport } from './routes/_app/stock-transfer_.$id_.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/index.lazy').then((d) => d.Route))
const AppCartonSizesRoute = AppCartonSizesRouteImport.update({
  id: '/carton-sizes',
  path: '/carton-sizes',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/carton-sizes.lazy').then((d) => d.Route),
)
const AppCategoriesRoute = AppCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/categories.lazy').then((d) => d.Route),
)
const AppClientCodesRoute = AppClientCodesRouteImport.update({
  id: '/client-codes',
  path: '/client-codes',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/client-codes.lazy').then((d) => d.Route),
)
const AppColoursRoute = AppColoursRouteImport.update({
  id: '/colours',
  path: '/colours',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/colours.lazy').then((d) => d.Route))
const AppDesignsRoute = AppDesignsRouteImport.update({
  id: '/designs',
  path: '/designs',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/designs.lazy').then((d) => d.Route))
const AppDriversRoute = AppDriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/drivers.lazy').then((d) => d.Route))
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppLocationsRoute = AppLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/locations.lazy').then((d) => d.Route),
)
const AppLogisticsAssignmentRoute = AppLogisticsAssignmentRouteImport.update({
  id: '/logistics-assignment',
  path: '/logistics-assignment',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/logistics-assignment.lazy').then((d) => d.Route),
)
const AppLogisticsCalendarRoute = AppLogisticsCalendarRouteImport.update({
  id: '/logistics-calendar',
  path: '/logistics-calendar',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/logistics-calendar.lazy').then((d) => d.Route),
)
const AppLogisticsDeliveriesRoute = AppLogisticsDeliveriesRouteImport.update({
  id: '/logistics-deliveries',
  path: '/logistics-deliveries',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/logistics-deliveries.lazy').then((d) => d.Route),
)
const AppLogisticsProductsRoute = AppLogisticsProductsRouteImport.update({
  id: '/logistics-products',
  path: '/logistics-products',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/logistics-products.lazy').then((d) => d.Route),
)
const AppLogisticsSyncRoute = AppLogisticsSyncRouteImport.update({
  id: '/logistics-sync',
  path: '/logistics-sync',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/logistics-sync.lazy').then((d) => d.Route),
)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/products.lazy').then((d) => d.Route))
const AppSizesRoute = AppSizesRouteImport.update({
  id: '/sizes',
  path: '/sizes',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/sizes.lazy').then((d) => d.Route))
const AppStockAdjustmentRoute = AppStockAdjustmentRouteImport.update({
  id: '/stock-adjustment',
  path: '/stock-adjustment',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-adjustment.lazy').then((d) => d.Route),
)
const AppStockInRoute = AppStockInRouteImport.update({
  id: '/stock-in',
  path: '/stock-in',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/stock-in.lazy').then((d) => d.Route))
const AppStockOutRoute = AppStockOutRouteImport.update({
  id: '/stock-out',
  path: '/stock-out',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-out.lazy').then((d) => d.Route),
)
const AppStockReservationRoute = AppStockReservationRouteImport.update({
  id: '/stock-reservation',
  path: '/stock-reservation',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-reservation.lazy').then((d) => d.Route),
)
const AppStockTransferRoute = AppStockTransferRouteImport.update({
  id: '/stock-transfer',
  path: '/stock-transfer',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-transfer.lazy').then((d) => d.Route),
)
const AppUserRolesRoute = AppUserRolesRouteImport.update({
  id: '/user-roles',
  path: '/user-roles',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/user-roles.lazy').then((d) => d.Route),
)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/users.lazy').then((d) => d.Route))
const AppVehiclesRoute = AppVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/vehicles.lazy').then((d) => d.Route))
const AppWarehousesRoute = AppWarehousesRouteImport.update({
  id: '/warehouses',
  path: '/warehouses',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/warehouses.lazy').then((d) => d.Route),
)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRoute,
} as any).lazy(() =>
  import('./routes/_app/inventory.index.lazy').then((d) => d.Route),
)
const AppInventoryByProductRoute = AppInventoryByProductRouteImport.update({
  id: '/by-product',
  path: '/by-product',
  getParentRoute: () => AppInventoryRoute,
} as any).lazy(() =>
  import('./routes/_app/inventory.by-product.lazy').then((d) => d.Route),
)
const AppInventoryDateBasedRoute = AppInventoryDateBasedRouteImport.update({
  id: '/date-based',
  path: '/date-based',
  getParentRoute: () => AppInventoryRoute,
} as any).lazy(() =>
  import('./routes/_app/inventory.date-based.lazy').then((d) => d.Route),
)
const AppInventorySummaryRoute = AppInventorySummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => AppInventoryRoute,
} as any).lazy(() =>
  import('./routes/_app/inventory.summary.lazy').then((d) => d.Route),
)
const AppLogisticsDeliveriesIdRoute =
  AppLogisticsDeliveriesIdRouteImport.update({
    id: '/logistics-deliveries_/$id',
    path: '/logistics-deliveries/$id',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/logistics-deliveries_.$id.lazy').then((d) => d.Route),
  )
const AppLogisticsDeliveriesNewRoute =
  AppLogisticsDeliveriesNewRouteImport.update({
    id: '/logistics-deliveries_/new',
    path: '/logistics-deliveries/new',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/logistics-deliveries_.new.lazy').then((d) => d.Route),
  )
const AppStockAdjustmentIdRoute = AppStockAdjustmentIdRouteImport.update({
  id: '/stock-adjustment_/$id',
  path: '/stock-adjustment/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-adjustment_.$id.lazy').then((d) => d.Route),
)
const AppStockAdjustmentNewRoute = AppStockAdjustmentNewRouteImport.update({
  id: '/stock-adjustment_/new',
  path: '/stock-adjustment/new',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-adjustment_.new.lazy').then((d) => d.Route),
)
const AppStockInIdRoute = AppStockInIdRouteImport.update({
  id: '/stock-in_/$id',
  path: '/stock-in/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-in_.$id.lazy').then((d) => d.Route),
)
const AppStockInNewRoute = AppStockInNewRouteImport.update({
  id: '/stock-in_/new',
  path: '/stock-in/new',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-in_.new.lazy').then((d) => d.Route),
)
const AppStockOutIdRoute = AppStockOutIdRouteImport.update({
  id: '/stock-out_/$id',
  path: '/stock-out/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-out_.$id.lazy').then((d) => d.Route),
)
const AppStockOutNewRoute = AppStockOutNewRouteImport.update({
  id: '/stock-out_/new',
  path: '/stock-out/new',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-out_.new.lazy').then((d) => d.Route),
)
const AppStockReservationIdRoute = AppStockReservationIdRouteImport.update({
  id: '/stock-reservation_/$id',
  path: '/stock-reservation/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-reservation_.$id.lazy').then((d) => d.Route),
)
const AppStockReservationNewRoute = AppStockReservationNewRouteImport.update({
  id: '/stock-reservation_/new',
  path: '/stock-reservation/new',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-reservation_.new.lazy').then((d) => d.Route),
)
const AppStockTransferIdRoute = AppStockTransferIdRouteImport.update({
  id: '/stock-transfer_/$id',
  path: '/stock-transfer/$id',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-transfer_.$id.lazy').then((d) => d.Route),
)
const AppStockTransferNewRoute = AppStockTransferNewRouteImport.update({
  id: '/stock-transfer_/new',
  path: '/stock-transfer/new',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-transfer_.new.lazy').then((d) => d.Route),
)
const AppStockValuationCostsRoute = AppStockValuationCostsRouteImport.update({
  id: '/stock-valuation/costs',
  path: '/stock-valuation/costs',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-valuation.costs.lazy').then((d) => d.Route),
)
const AppStockValuationReceiptsRoute =
  AppStockValuationReceiptsRouteImport.update({
    id: '/stock-valuation/receipts',
    path: '/stock-valuation/receipts',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/stock-valuation.receipts.lazy').then((d) => d.Route),
  )
const AppStockValuationReportRoute = AppStockValuationReportRouteImport.update({
  id: '/stock-valuation/report',
  path: '/stock-valuation/report',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-valuation.report.lazy').then((d) => d.Route),
)
const AppLogisticsDeliveriesIdEditRoute =
  AppLogisticsDeliveriesIdEditRouteImport.update({
    id: '/logistics-deliveries_/$id_/edit',
    path: '/logistics-deliveries/$id/edit',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/logistics-deliveries_.$id_.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AppStockAdjustmentIdEditRoute =
  AppStockAdjustmentIdEditRouteImport.update({
    id: '/stock-adjustment_/$id_/edit',
    path: '/stock-adjustment/$id/edit',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/stock-adjustment_.$id_.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AppStockInIdEditRoute = AppStockInIdEditRouteImport.update({
  id: '/stock-in_/$id_/edit',
  path: '/stock-in/$id/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-in_.$id_.edit.lazy').then((d) => d.Route),
)
const AppStockOutIdEditRoute = AppStockOutIdEditRouteImport.update({
  id: '/stock-out_/$id_/edit',
  path: '/stock-out/$id/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-out_.$id_.edit.lazy').then((d) => d.Route),
)
const AppStockReservationIdEditRoute =
  AppStockReservationIdEditRouteImport.update({
    id: '/stock-reservation_/$id_/edit',
    path: '/stock-reservation/$id/edit',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/stock-reservation_.$id_.edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AppStockTransferIdEditRoute = AppStockTransferIdEditRouteImport.update({
  id: '/stock-transfer_/$id_/edit',
  path: '/stock-transfer/$id/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/stock-transfer_.$id_.edit.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/carton-sizes': typeof AppCartonSizesRoute
  '/categories': typeof AppCategoriesRoute
  '/client-codes': typeof AppClientCodesRoute
  '/colours': typeof AppColoursRoute
  '/designs': typeof AppDesignsRoute
  '/drivers': typeof AppDriversRoute
  '/inventory': typeof AppInventoryRouteWithChildren
  '/locations': typeof AppLocationsRoute
  '/logistics-assignment': typeof AppLogisticsAssignmentRoute
  '/logistics-calendar': typeof AppLogisticsCalendarRoute
  '/logistics-deliveries': typeof AppLogisticsDeliveriesRoute
  '/logistics-products': typeof AppLogisticsProductsRoute
  '/logistics-sync': typeof AppLogisticsSyncRoute
  '/products': typeof AppProductsRoute
  '/sizes': typeof AppSizesRoute
  '/stock-adjustment': typeof AppStockAdjustmentRoute
  '/stock-in': typeof AppStockInRoute
  '/stock-out': typeof AppStockOutRoute
  '/stock-reservation': typeof AppStockReservationRoute
  '/stock-transfer': typeof AppStockTransferRoute
  '/user-roles': typeof AppUserRolesRoute
  '/users': typeof AppUsersRoute
  '/vehicles': typeof AppVehiclesRoute
  '/warehouses': typeof AppWarehousesRoute
  '/inventory/by-product': typeof AppInventoryByProductRoute
  '/inventory/date-based': typeof AppInventoryDateBasedRoute
  '/inventory/summary': typeof AppInventorySummaryRoute
  '/logistics-deliveries/$id': typeof AppLogisticsDeliveriesIdRoute
  '/logistics-deliveries/new': typeof AppLogisticsDeliveriesNewRoute
  '/stock-adjustment/$id': typeof AppStockAdjustmentIdRoute
  '/stock-adjustment/new': typeof AppStockAdjustmentNewRoute
  '/stock-in/$id': typeof AppStockInIdRoute
  '/stock-in/new': typeof AppStockInNewRoute
  '/stock-out/$id': typeof AppStockOutIdRoute
  '/stock-out/new': typeof AppStockOutNewRoute
  '/stock-reservation/$id': typeof AppStockReservationIdRoute
  '/stock-reservation/new': typeof AppStockReservationNewRoute
  '/stock-transfer/$id': typeof AppStockTransferIdRoute
  '/stock-transfer/new': typeof AppStockTransferNewRoute
  '/stock-valuation/costs': typeof AppStockValuationCostsRoute
  '/stock-valuation/receipts': typeof AppStockValuationReceiptsRoute
  '/stock-valuation/report': typeof AppStockValuationReportRoute
  '/inventory/': typeof AppInventoryIndexRoute
  '/logistics-deliveries/$id/edit': typeof AppLogisticsDeliveriesIdEditRoute
  '/stock-adjustment/$id/edit': typeof AppStockAdjustmentIdEditRoute
  '/stock-in/$id/edit': typeof AppStockInIdEditRoute
  '/stock-out/$id/edit': typeof AppStockOutIdEditRoute
  '/stock-reservation/$id/edit': typeof AppStockReservationIdEditRoute
  '/stock-transfer/$id/edit': typeof AppStockTransferIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/carton-sizes': typeof AppCartonSizesRoute
  '/categories': typeof AppCategoriesRoute
  '/client-codes': typeof AppClientCodesRoute
  '/colours': typeof AppColoursRoute
  '/designs': typeof AppDesignsRoute
  '/drivers': typeof AppDriversRoute
  '/locations': typeof AppLocationsRoute
  '/logistics-assignment': typeof AppLogisticsAssignmentRoute
  '/logistics-calendar': typeof AppLogisticsCalendarRoute
  '/logistics-deliveries': typeof AppLogisticsDeliveriesRoute
  '/logistics-products': typeof AppLogisticsProductsRoute
  '/logistics-sync': typeof AppLogisticsSyncRoute
  '/products': typeof AppProductsRoute
  '/sizes': typeof AppSizesRoute
  '/stock-adjustment': typeof AppStockAdjustmentRoute
  '/stock-in': typeof AppStockInRoute
  '/stock-out': typeof AppStockOutRoute
  '/stock-reservation': typeof AppStockReservationRoute
  '/stock-transfer': typeof AppStockTransferRoute
  '/user-roles': typeof AppUserRolesRoute
  '/users': typeof AppUsersRoute
  '/vehicles': typeof AppVehiclesRoute
  '/warehouses': typeof AppWarehousesRoute
  '/': typeof AppIndexRoute
  '/inventory/by-product': typeof AppInventoryByProductRoute
  '/inventory/date-based': typeof AppInventoryDateBasedRoute
  '/inventory/summary': typeof AppInventorySummaryRoute
  '/logistics-deliveries/$id': typeof AppLogisticsDeliveriesIdRoute
  '/logistics-deliveries/new': typeof AppLogisticsDeliveriesNewRoute
  '/stock-adjustment/$id': typeof AppStockAdjustmentIdRoute
  '/stock-adjustment/new': typeof AppStockAdjustmentNewRoute
  '/stock-in/$id': typeof AppStockInIdRoute
  '/stock-in/new': typeof AppStockInNewRoute
  '/stock-out/$id': typeof AppStockOutIdRoute
  '/stock-out/new': typeof AppStockOutNewRoute
  '/stock-reservation/$id': typeof AppStockReservationIdRoute
  '/stock-reservation/new': typeof AppStockReservationNewRoute
  '/stock-transfer/$id': typeof AppStockTransferIdRoute
  '/stock-transfer/new': typeof AppStockTransferNewRoute
  '/stock-valuation/costs': typeof AppStockValuationCostsRoute
  '/stock-valuation/receipts': typeof AppStockValuationReceiptsRoute
  '/stock-valuation/report': typeof AppStockValuationReportRoute
  '/inventory': typeof AppInventoryIndexRoute
  '/logistics-deliveries/$id/edit': typeof AppLogisticsDeliveriesIdEditRoute
  '/stock-adjustment/$id/edit': typeof AppStockAdjustmentIdEditRoute
  '/stock-in/$id/edit': typeof AppStockInIdEditRoute
  '/stock-out/$id/edit': typeof AppStockOutIdEditRoute
  '/stock-reservation/$id/edit': typeof AppStockReservationIdEditRoute
  '/stock-transfer/$id/edit': typeof AppStockTransferIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/carton-sizes': typeof AppCartonSizesRoute
  '/_app/categories': typeof AppCategoriesRoute
  '/_app/client-codes': typeof AppClientCodesRoute
  '/_app/colours': typeof AppColoursRoute
  '/_app/designs': typeof AppDesignsRoute
  '/_app/drivers': typeof AppDriversRoute
  '/_app/inventory': typeof AppInventoryRouteWithChildren
  '/_app/locations': typeof AppLocationsRoute
  '/_app/logistics-assignment': typeof AppLogisticsAssignmentRoute
  '/_app/logistics-calendar': typeof AppLogisticsCalendarRoute
  '/_app/logistics-deliveries': typeof AppLogisticsDeliveriesRoute
  '/_app/logistics-products': typeof AppLogisticsProductsRoute
  '/_app/logistics-sync': typeof AppLogisticsSyncRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/sizes': typeof AppSizesRoute
  '/_app/stock-adjustment': typeof AppStockAdjustmentRoute
  '/_app/stock-in': typeof AppStockInRoute
  '/_app/stock-out': typeof AppStockOutRoute
  '/_app/stock-reservation': typeof AppStockReservationRoute
  '/_app/stock-transfer': typeof AppStockTransferRoute
  '/_app/user-roles': typeof AppUserRolesRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/vehicles': typeof AppVehiclesRoute
  '/_app/warehouses': typeof AppWarehousesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/inventory/by-product': typeof AppInventoryByProductRoute
  '/_app/inventory/date-based': typeof AppInventoryDateBasedRoute
  '/_app/inventory/summary': typeof AppInventorySummaryRoute
  '/_app/logistics-deliveries_/$id': typeof AppLogisticsDeliveriesIdRoute
  '/_app/logistics-deliveries_/new': typeof AppLogisticsDeliveriesNewRoute
  '/_app/stock-adjustment_/$id': typeof AppStockAdjustmentIdRoute
  '/_app/stock-adjustment_/new': typeof AppStockAdjustmentNewRoute
  '/_app/stock-in_/$id': typeof AppStockInIdRoute
  '/_app/stock-in_/new': typeof AppStockInNewRoute
  '/_app/stock-out_/$id': typeof AppStockOutIdRoute
  '/_app/stock-out_/new': typeof AppStockOutNewRoute
  '/_app/stock-reservation_/$id': typeof AppStockReservationIdRoute
  '/_app/stock-reservation_/new': typeof AppStockReservationNewRoute
  '/_app/stock-transfer_/$id': typeof AppStockTransferIdRoute
  '/_app/stock-transfer_/new': typeof AppStockTransferNewRoute
  '/_app/stock-valuation/costs': typeof AppStockValuationCostsRoute
  '/_app/stock-valuation/receipts': typeof AppStockValuationReceiptsRoute
  '/_app/stock-valuation/report': typeof AppStockValuationReportRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
  '/_app/logistics-deliveries_/$id_/edit': typeof AppLogisticsDeliveriesIdEditRoute
  '/_app/stock-adjustment_/$id_/edit': typeof AppStockAdjustmentIdEditRoute
  '/_app/stock-in_/$id_/edit': typeof AppStockInIdEditRoute
  '/_app/stock-out_/$id_/edit': typeof AppStockOutIdEditRoute
  '/_app/stock-reservation_/$id_/edit': typeof AppStockReservationIdEditRoute
  '/_app/stock-transfer_/$id_/edit': typeof AppStockTransferIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/carton-sizes'
    | '/categories'
    | '/client-codes'
    | '/colours'
    | '/designs'
    | '/drivers'
    | '/inventory'
    | '/locations'
    | '/logistics-assignment'
    | '/logistics-calendar'
    | '/logistics-deliveries'
    | '/logistics-products'
    | '/logistics-sync'
    | '/products'
    | '/sizes'
    | '/stock-adjustment'
    | '/stock-in'
    | '/stock-out'
    | '/stock-reservation'
    | '/stock-transfer'
    | '/user-roles'
    | '/users'
    | '/vehicles'
    | '/warehouses'
    | '/inventory/by-product'
    | '/inventory/date-based'
    | '/inventory/summary'
    | '/logistics-deliveries/$id'
    | '/logistics-deliveries/new'
    | '/stock-adjustment/$id'
    | '/stock-adjustment/new'
    | '/stock-in/$id'
    | '/stock-in/new'
    | '/stock-out/$id'
    | '/stock-out/new'
    | '/stock-reservation/$id'
    | '/stock-reservation/new'
    | '/stock-transfer/$id'
    | '/stock-transfer/new'
    | '/stock-valuation/costs'
    | '/stock-valuation/receipts'
    | '/stock-valuation/report'
    | '/inventory/'
    | '/logistics-deliveries/$id/edit'
    | '/stock-adjustment/$id/edit'
    | '/stock-in/$id/edit'
    | '/stock-out/$id/edit'
    | '/stock-reservation/$id/edit'
    | '/stock-transfer/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/carton-sizes'
    | '/categories'
    | '/client-codes'
    | '/colours'
    | '/designs'
    | '/drivers'
    | '/locations'
    | '/logistics-assignment'
    | '/logistics-calendar'
    | '/logistics-deliveries'
    | '/logistics-products'
    | '/logistics-sync'
    | '/products'
    | '/sizes'
    | '/stock-adjustment'
    | '/stock-in'
    | '/stock-out'
    | '/stock-reservation'
    | '/stock-transfer'
    | '/user-roles'
    | '/users'
    | '/vehicles'
    | '/warehouses'
    | '/'
    | '/inventory/by-product'
    | '/inventory/date-based'
    | '/inventory/summary'
    | '/logistics-deliveries/$id'
    | '/logistics-deliveries/new'
    | '/stock-adjustment/$id'
    | '/stock-adjustment/new'
    | '/stock-in/$id'
    | '/stock-in/new'
    | '/stock-out/$id'
    | '/stock-out/new'
    | '/stock-reservation/$id'
    | '/stock-reservation/new'
    | '/stock-transfer/$id'
    | '/stock-transfer/new'
    | '/stock-valuation/costs'
    | '/stock-valuation/receipts'
    | '/stock-valuation/report'
    | '/inventory'
    | '/logistics-deliveries/$id/edit'
    | '/stock-adjustment/$id/edit'
    | '/stock-in/$id/edit'
    | '/stock-out/$id/edit'
    | '/stock-reservation/$id/edit'
    | '/stock-transfer/$id/edit'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/carton-sizes'
    | '/_app/categories'
    | '/_app/client-codes'
    | '/_app/colours'
    | '/_app/designs'
    | '/_app/drivers'
    | '/_app/inventory'
    | '/_app/locations'
    | '/_app/logistics-assignment'
    | '/_app/logistics-calendar'
    | '/_app/logistics-deliveries'
    | '/_app/logistics-products'
    | '/_app/logistics-sync'
    | '/_app/products'
    | '/_app/sizes'
    | '/_app/stock-adjustment'
    | '/_app/stock-in'
    | '/_app/stock-out'
    | '/_app/stock-reservation'
    | '/_app/stock-transfer'
    | '/_app/user-roles'
    | '/_app/users'
    | '/_app/vehicles'
    | '/_app/warehouses'
    | '/_app/'
    | '/_app/inventory/by-product'
    | '/_app/inventory/date-based'
    | '/_app/inventory/summary'
    | '/_app/logistics-deliveries_/$id'
    | '/_app/logistics-deliveries_/new'
    | '/_app/stock-adjustment_/$id'
    | '/_app/stock-adjustment_/new'
    | '/_app/stock-in_/$id'
    | '/_app/stock-in_/new'
    | '/_app/stock-out_/$id'
    | '/_app/stock-out_/new'
    | '/_app/stock-reservation_/$id'
    | '/_app/stock-reservation_/new'
    | '/_app/stock-transfer_/$id'
    | '/_app/stock-transfer_/new'
    | '/_app/stock-valuation/costs'
    | '/_app/stock-valuation/receipts'
    | '/_app/stock-valuation/report'
    | '/_app/inventory/'
    | '/_app/logistics-deliveries_/$id_/edit'
    | '/_app/stock-adjustment_/$id_/edit'
    | '/_app/stock-in_/$id_/edit'
    | '/_app/stock-out_/$id_/edit'
    | '/_app/stock-reservation_/$id_/edit'
    | '/_app/stock-transfer_/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/carton-sizes': {
      id: '/_app/carton-sizes'
      path: '/carton-sizes'
      fullPath: '/carton-sizes'
      preLoaderRoute: typeof AppCartonSizesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/categories': {
      id: '/_app/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AppCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/client-codes': {
      id: '/_app/client-codes'
      path: '/client-codes'
      fullPath: '/client-codes'
      preLoaderRoute: typeof AppClientCodesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/colours': {
      id: '/_app/colours'
      path: '/colours'
      fullPath: '/colours'
      preLoaderRoute: typeof AppColoursRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/designs': {
      id: '/_app/designs'
      path: '/designs'
      fullPath: '/designs'
      preLoaderRoute: typeof AppDesignsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drivers': {
      id: '/_app/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof AppDriversRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/locations': {
      id: '/_app/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof AppLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-assignment': {
      id: '/_app/logistics-assignment'
      path: '/logistics-assignment'
      fullPath: '/logistics-assignment'
      preLoaderRoute: typeof AppLogisticsAssignmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-calendar': {
      id: '/_app/logistics-calendar'
      path: '/logistics-calendar'
      fullPath: '/logistics-calendar'
      preLoaderRoute: typeof AppLogisticsCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-deliveries': {
      id: '/_app/logistics-deliveries'
      path: '/logistics-deliveries'
      fullPath: '/logistics-deliveries'
      preLoaderRoute: typeof AppLogisticsDeliveriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-products': {
      id: '/_app/logistics-products'
      path: '/logistics-products'
      fullPath: '/logistics-products'
      preLoaderRoute: typeof AppLogisticsProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-sync': {
      id: '/_app/logistics-sync'
      path: '/logistics-sync'
      fullPath: '/logistics-sync'
      preLoaderRoute: typeof AppLogisticsSyncRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sizes': {
      id: '/_app/sizes'
      path: '/sizes'
      fullPath: '/sizes'
      preLoaderRoute: typeof AppSizesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-adjustment': {
      id: '/_app/stock-adjustment'
      path: '/stock-adjustment'
      fullPath: '/stock-adjustment'
      preLoaderRoute: typeof AppStockAdjustmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-in': {
      id: '/_app/stock-in'
      path: '/stock-in'
      fullPath: '/stock-in'
      preLoaderRoute: typeof AppStockInRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-out': {
      id: '/_app/stock-out'
      path: '/stock-out'
      fullPath: '/stock-out'
      preLoaderRoute: typeof AppStockOutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-reservation': {
      id: '/_app/stock-reservation'
      path: '/stock-reservation'
      fullPath: '/stock-reservation'
      preLoaderRoute: typeof AppStockReservationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-transfer': {
      id: '/_app/stock-transfer'
      path: '/stock-transfer'
      fullPath: '/stock-transfer'
      preLoaderRoute: typeof AppStockTransferRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-roles': {
      id: '/_app/user-roles'
      path: '/user-roles'
      fullPath: '/user-roles'
      preLoaderRoute: typeof AppUserRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicles': {
      id: '/_app/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AppVehiclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/warehouses': {
      id: '/_app/warehouses'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof AppWarehousesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/by-product': {
      id: '/_app/inventory/by-product'
      path: '/by-product'
      fullPath: '/inventory/by-product'
      preLoaderRoute: typeof AppInventoryByProductRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/date-based': {
      id: '/_app/inventory/date-based'
      path: '/date-based'
      fullPath: '/inventory/date-based'
      preLoaderRoute: typeof AppInventoryDateBasedRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/summary': {
      id: '/_app/inventory/summary'
      path: '/summary'
      fullPath: '/inventory/summary'
      preLoaderRoute: typeof AppInventorySummaryRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/logistics-deliveries_/$id': {
      id: '/_app/logistics-deliveries_/$id'
      path: '/logistics-deliveries/$id'
      fullPath: '/logistics-deliveries/$id'
      preLoaderRoute: typeof AppLogisticsDeliveriesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-deliveries_/new': {
      id: '/_app/logistics-deliveries_/new'
      path: '/logistics-deliveries/new'
      fullPath: '/logistics-deliveries/new'
      preLoaderRoute: typeof AppLogisticsDeliveriesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-adjustment_/$id': {
      id: '/_app/stock-adjustment_/$id'
      path: '/stock-adjustment/$id'
      fullPath: '/stock-adjustment/$id'
      preLoaderRoute: typeof AppStockAdjustmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-adjustment_/new': {
      id: '/_app/stock-adjustment_/new'
      path: '/stock-adjustment/new'
      fullPath: '/stock-adjustment/new'
      preLoaderRoute: typeof AppStockAdjustmentNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-in_/$id': {
      id: '/_app/stock-in_/$id'
      path: '/stock-in/$id'
      fullPath: '/stock-in/$id'
      preLoaderRoute: typeof AppStockInIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-in_/new': {
      id: '/_app/stock-in_/new'
      path: '/stock-in/new'
      fullPath: '/stock-in/new'
      preLoaderRoute: typeof AppStockInNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-out_/$id': {
      id: '/_app/stock-out_/$id'
      path: '/stock-out/$id'
      fullPath: '/stock-out/$id'
      preLoaderRoute: typeof AppStockOutIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-out_/new': {
      id: '/_app/stock-out_/new'
      path: '/stock-out/new'
      fullPath: '/stock-out/new'
      preLoaderRoute: typeof AppStockOutNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-reservation_/$id': {
      id: '/_app/stock-reservation_/$id'
      path: '/stock-reservation/$id'
      fullPath: '/stock-reservation/$id'
      preLoaderRoute: typeof AppStockReservationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-reservation_/new': {
      id: '/_app/stock-reservation_/new'
      path: '/stock-reservation/new'
      fullPath: '/stock-reservation/new'
      preLoaderRoute: typeof AppStockReservationNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-transfer_/$id': {
      id: '/_app/stock-transfer_/$id'
      path: '/stock-transfer/$id'
      fullPath: '/stock-transfer/$id'
      preLoaderRoute: typeof AppStockTransferIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-transfer_/new': {
      id: '/_app/stock-transfer_/new'
      path: '/stock-transfer/new'
      fullPath: '/stock-transfer/new'
      preLoaderRoute: typeof AppStockTransferNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-valuation/costs': {
      id: '/_app/stock-valuation/costs'
      path: '/stock-valuation/costs'
      fullPath: '/stock-valuation/costs'
      preLoaderRoute: typeof AppStockValuationCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-valuation/receipts': {
      id: '/_app/stock-valuation/receipts'
      path: '/stock-valuation/receipts'
      fullPath: '/stock-valuation/receipts'
      preLoaderRoute: typeof AppStockValuationReceiptsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-valuation/report': {
      id: '/_app/stock-valuation/report'
      path: '/stock-valuation/report'
      fullPath: '/stock-valuation/report'
      preLoaderRoute: typeof AppStockValuationReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics-deliveries_/$id_/edit': {
      id: '/_app/logistics-deliveries_/$id_/edit'
      path: '/logistics-deliveries/$id/edit'
      fullPath: '/logistics-deliveries/$id/edit'
      preLoaderRoute: typeof AppLogisticsDeliveriesIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-adjustment_/$id_/edit': {
      id: '/_app/stock-adjustment_/$id_/edit'
      path: '/stock-adjustment/$id/edit'
      fullPath: '/stock-adjustment/$id/edit'
      preLoaderRoute: typeof AppStockAdjustmentIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-in_/$id_/edit': {
      id: '/_app/stock-in_/$id_/edit'
      path: '/stock-in/$id/edit'
      fullPath: '/stock-in/$id/edit'
      preLoaderRoute: typeof AppStockInIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-out_/$id_/edit': {
      id: '/_app/stock-out_/$id_/edit'
      path: '/stock-out/$id/edit'
      fullPath: '/stock-out/$id/edit'
      preLoaderRoute: typeof AppStockOutIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-reservation_/$id_/edit': {
      id: '/_app/stock-reservation_/$id_/edit'
      path: '/stock-reservation/$id/edit'
      fullPath: '/stock-reservation/$id/edit'
      preLoaderRoute: typeof AppStockReservationIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock-transfer_/$id_/edit': {
      id: '/_app/stock-transfer_/$id_/edit'
      path: '/stock-transfer/$id/edit'
      fullPath: '/stock-transfer/$id/edit'
      preLoaderRoute: typeof AppStockTransferIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppInventoryRouteChildren {
  AppInventoryByProductRoute: typeof AppInventoryByProductRoute
  AppInventoryDateBasedRoute: typeof AppInventoryDateBasedRoute
  AppInventorySummaryRoute: typeof AppInventorySummaryRoute
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
}

const AppInventoryRouteChildren: AppInventoryRouteChildren = {
  AppInventoryByProductRoute: AppInventoryByProductRoute,
  AppInventoryDateBasedRoute: AppInventoryDateBasedRoute,
  AppInventorySummaryRoute: AppInventorySummaryRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
}

const AppInventoryRouteWithChildren = AppInventoryRoute._addFileChildren(
  AppInventoryRouteChildren,
)

interface AppRouteChildren {
  AppCartonSizesRoute: typeof AppCartonSizesRoute
  AppCategoriesRoute: typeof AppCategoriesRoute
  AppClientCodesRoute: typeof AppClientCodesRoute
  AppColoursRoute: typeof AppColoursRoute
  AppDesignsRoute: typeof AppDesignsRoute
  AppDriversRoute: typeof AppDriversRoute
  AppInventoryRoute: typeof AppInventoryRouteWithChildren
  AppLocationsRoute: typeof AppLocationsRoute
  AppLogisticsAssignmentRoute: typeof AppLogisticsAssignmentRoute
  AppLogisticsCalendarRoute: typeof AppLogisticsCalendarRoute
  AppLogisticsDeliveriesRoute: typeof AppLogisticsDeliveriesRoute
  AppLogisticsProductsRoute: typeof AppLogisticsProductsRoute
  AppLogisticsSyncRoute: typeof AppLogisticsSyncRoute
  AppProductsRoute: typeof AppProductsRoute
  AppSizesRoute: typeof AppSizesRoute
  AppStockAdjustmentRoute: typeof AppStockAdjustmentRoute
  AppStockInRoute: typeof AppStockInRoute
  AppStockOutRoute: typeof AppStockOutRoute
  AppStockReservationRoute: typeof AppStockReservationRoute
  AppStockTransferRoute: typeof AppStockTransferRoute
  AppUserRolesRoute: typeof AppUserRolesRoute
  AppUsersRoute: typeof AppUsersRoute
  AppVehiclesRoute: typeof AppVehiclesRoute
  AppWarehousesRoute: typeof AppWarehousesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppLogisticsDeliveriesIdRoute: typeof AppLogisticsDeliveriesIdRoute
  AppLogisticsDeliveriesNewRoute: typeof AppLogisticsDeliveriesNewRoute
  AppStockAdjustmentIdRoute: typeof AppStockAdjustmentIdRoute
  AppStockAdjustmentNewRoute: typeof AppStockAdjustmentNewRoute
  AppStockInIdRoute: typeof AppStockInIdRoute
  AppStockInNewRoute: typeof AppStockInNewRoute
  AppStockOutIdRoute: typeof AppStockOutIdRoute
  AppStockOutNewRoute: typeof AppStockOutNewRoute
  AppStockReservationIdRoute: typeof AppStockReservationIdRoute
  AppStockReservationNewRoute: typeof AppStockReservationNewRoute
  AppStockTransferIdRoute: typeof AppStockTransferIdRoute
  AppStockTransferNewRoute: typeof AppStockTransferNewRoute
  AppStockValuationCostsRoute: typeof AppStockValuationCostsRoute
  AppStockValuationReceiptsRoute: typeof AppStockValuationReceiptsRoute
  AppStockValuationReportRoute: typeof AppStockValuationReportRoute
  AppLogisticsDeliveriesIdEditRoute: typeof AppLogisticsDeliveriesIdEditRoute
  AppStockAdjustmentIdEditRoute: typeof AppStockAdjustmentIdEditRoute
  AppStockInIdEditRoute: typeof AppStockInIdEditRoute
  AppStockOutIdEditRoute: typeof AppStockOutIdEditRoute
  AppStockReservationIdEditRoute: typeof AppStockReservationIdEditRoute
  AppStockTransferIdEditRoute: typeof AppStockTransferIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCartonSizesRoute: AppCartonSizesRoute,
  AppCategoriesRoute: AppCategoriesRoute,
  AppClientCodesRoute: AppClientCodesRoute,
  AppColoursRoute: AppColoursRoute,
  AppDesignsRoute: AppDesignsRoute,
  AppDriversRoute: AppDriversRoute,
  AppInventoryRoute: AppInventoryRouteWithChildren,
  AppLocationsRoute: AppLocationsRoute,
  AppLogisticsAssignmentRoute: AppLogisticsAssignmentRoute,
  AppLogisticsCalendarRoute: AppLogisticsCalendarRoute,
  AppLogisticsDeliveriesRoute: AppLogisticsDeliveriesRoute,
  AppLogisticsProductsRoute: AppLogisticsProductsRoute,
  AppLogisticsSyncRoute: AppLogisticsSyncRoute,
  AppProductsRoute: AppProductsRoute,
  AppSizesRoute: AppSizesRoute,
  AppStockAdjustmentRoute: AppStockAdjustmentRoute,
  AppStockInRoute: AppStockInRoute,
  AppStockOutRoute: AppStockOutRoute,
  AppStockReservationRoute: AppStockReservationRoute,
  AppStockTransferRoute: AppStockTransferRoute,
  AppUserRolesRoute: AppUserRolesRoute,
  AppUsersRoute: AppUsersRoute,
  AppVehiclesRoute: AppVehiclesRoute,
  AppWarehousesRoute: AppWarehousesRoute,
  AppIndexRoute: AppIndexRoute,
  AppLogisticsDeliveriesIdRoute: AppLogisticsDeliveriesIdRoute,
  AppLogisticsDeliveriesNewRoute: AppLogisticsDeliveriesNewRoute,
  AppStockAdjustmentIdRoute: AppStockAdjustmentIdRoute,
  AppStockAdjustmentNewRoute: AppStockAdjustmentNewRoute,
  AppStockInIdRoute: AppStockInIdRoute,
  AppStockInNewRoute: AppStockInNewRoute,
  AppStockOutIdRoute: AppStockOutIdRoute,
  AppStockOutNewRoute: AppStockOutNewRoute,
  AppStockReservationIdRoute: AppStockReservationIdRoute,
  AppStockReservationNewRoute: AppStockReservationNewRoute,
  AppStockTransferIdRoute: AppStockTransferIdRoute,
  AppStockTransferNewRoute: AppStockTransferNewRoute,
  AppStockValuationCostsRoute: AppStockValuationCostsRoute,
  AppStockValuationReceiptsRoute: AppStockValuationReceiptsRoute,
  AppStockValuationReportRoute: AppStockValuationReportRoute,
  AppLogisticsDeliveriesIdEditRoute: AppLogisticsDeliveriesIdEditRoute,
  AppStockAdjustmentIdEditRoute: AppStockAdjustmentIdEditRoute,
  AppStockInIdEditRoute: AppStockInIdEditRoute,
  AppStockOutIdEditRoute: AppStockOutIdEditRoute,
  AppStockReservationIdEditRoute: AppStockReservationIdEditRoute,
  AppStockTransferIdEditRoute: AppStockTransferIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
